import * as React from "react";
const SvgFiRrPlanetMoon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-planet-moon_svg__a)">
      <path
        fill="#062147"
        d="M10.5 3C4.71 3 0 7.71 0 13.5S4.71 24 10.5 24 21 19.29 21 13.5 16.29 3 10.5 3m0 19C5.813 22 2 18.187 2 13.5c0-1.328.306-2.586.852-3.707l.852.896c.189.198.451.311.725.311H6.61a.94.94 0 0 1 .666.276l.448.448A.94.94 0 0 1 8 12.39v.781a2 2 0 0 0 .586 1.414l1.138 1.138a.94.94 0 0 1 .276.666v1.482c0 .623.505 1.128 1.128 1.128h.491c.413 0 .793-.226.99-.588l2.254-4.133a.94.94 0 0 0-.328-1.25l-3.05-1.726a2 2 0 0 0-1.06-.304H8.889a.94.94 0 0 1-.666-.276l-.558-.558a.94.94 0 0 1 0-1.332l.354-.354a.94.94 0 0 1 1.087-.176l.786.393a.943.943 0 0 0 1.229-1.327l-.82-1.366a.94.94 0 0 1 .02-1.001l.179-.002c4.687 0 8.5 3.813 8.5 8.5S15.187 22 10.5 22M24 2.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-planet-moon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlanetMoon;
